var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg7Pos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.18 31.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".yellow{fill:currentColor;}.black{fill:#2f2e2b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "yellow",
    d: "M27.55,7.54H22.33V5.31H23.7v.86h2.48V5.31h1.37Zm-17.71,0H4.62V5.31H6v.86H8.47V5.31H9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "black",
    d: "M30,3.08h-2.4V1.46A1.45,1.45,0,0,0,26.1,0H23.79a1.46,1.46,0,0,0-1.46,1.46V3.08H9.84V1.46A1.45,1.45,0,0,0,8.39,0H6.07A1.45,1.45,0,0,0,4.62,1.46V3.08H2.22A2.23,2.23,0,0,0,0,5.31V29.18a2.24,2.24,0,0,0,2.22,2.23H30a2.24,2.24,0,0,0,2.23-2.23V5.31A2.24,2.24,0,0,0,30,3.08ZM2.22,4.45H6v-3a.09.09,0,0,1,.09-.09H8.39a.09.09,0,0,1,.08.09v3H23.7v-3a.09.09,0,0,1,.09-.09H26.1a.08.08,0,0,1,.08.09v3H30a.86.86,0,0,1,.86.86V9.24H1.37V5.31A.85.85,0,0,1,2.22,4.45ZM30,30H2.23a.86.86,0,0,1-.86-.86V10.61H30.81V29.18A.87.87,0,0,1,30,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "yellow",
    d: "M20.71,24.48H17.63V23.11h3.08Zm-6.16,0H11.47V23.11h3.08Zm-6.16,0H5.31V23.11H8.39Zm18.48-3.86H23.79V19.25h3.08Zm-6.17,0H17.62V19.25H20.7Zm-6.16,0H11.46V19.25h3.08Zm-6.16,0H5.3V19.25H8.38Zm18.48-3.85H23.78V15.4h3.08Zm-6.16,0H17.62V15.4H20.7Zm-6.16,0H11.46V15.4h3.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7Pos);
export default __webpack_public_path__ + "static/media/7-pos.58193698.svg";
export { ForwardRef as ReactComponent };